import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../config.service';
import { User } from 'src/app/shared/models/user';
import { ClientService } from '../client/client.service';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SplunkService {
  postData = {
    event: {
      application: "PartnerCenter_Rewrite",
      data: {},
      name: null
    }
  };
  currentUserSubscription: Subscription;
  currentUser: User;

  clientId: number;
  constructor(private configService: ConfigService,
    private http: HttpClient,

  ) {

  }

  log(eventName: any, data: any, userId: any, clientId = 0) {
    // const apiUrl = this.configService.splunkUrl + '/splunk/events';
    // this.postData.event.application = this.configService.splunkApplicationName;
    // this.postData.event.name = eventName;
    // this.postData.event.data = data;
    // this.postData.event.data['userId'] = userId;
    // this.postData.event.data['clientId'] = clientId;
    //if (eventName === 'error' || eventName === 'info' || (this.configService.enableDebugSplunkLogging) || eventName === 'PC_User_Log')
    // this.http.post<any>(apiUrl, [this.postData]).subscribe();
  }
}
